export default __webpack_public_path__ + "static/claude-9d0e85edcbaebf028b0151eb48a4c402.png";